import { Box, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { RewardsSectionProps } from './RewardsSection.types';

function RewardsSection({ titleLocKey, children }: RewardsSectionProps) {
  return (
    <Box gap="space-300" testID={`rewards-section-${titleLocKey}`}>
      <Text
        variant="h6"
        locNS="rewards"
        locKey={titleLocKey}
        gradient="darkSurfaceAccent"
      />
      {children}
    </Box>
  );
}

export default memo(RewardsSection);
